import apiClient from './apiClient'

export interface NotificationTodoPrompt {
  header?: string
  description?: string
}

export interface NotificationCounts {
  notification?: number
  release_notes?: number
  system_announcement?: number
  total?: number
  todo?: NotificationTodoPrompt
}

/**
 * Fetch unread counts for drawer badges (matches Angular loadNotificationsCount).
 */
export async function fetchNotificationCounts(): Promise<NotificationCounts> {
  const response = await apiClient.get<NotificationCounts>('/api/notification_count', {
    params: { timezone: new Date().getTimezoneOffset() },
  })
  return response.data
}
